export default __webpack_public_path__ + "static/media/video-preview.0dc1a8e8.jpg";